export const RATINGS_WITH_REVIEWS_TEXT = "RATINGS_WITH_REVIEWS_TEXT";
export const RATINGS_WITHOUT_REVIEWS_TEXT = "RATINGS_WITHOUT_REVIEWS_TEXT";
export const RATINGS_LARGE = "RATINGS_LARGE";

export const RATING_TYPES = [
  RATINGS_WITH_REVIEWS_TEXT,
  RATINGS_WITHOUT_REVIEWS_TEXT,
  RATINGS_LARGE,
];
